export default {"src":"/_next/static/media/google-logo.3c0c6682.svg","height":24,"width":24};